export const PREFIX = 'finance - landing';

export const PAGES = {
  MARKETING: 'marketing',
  PREQUALIFIED: 'prequalified'
};

export const SECTION = {
  ALLCREDITTYPES: 'all credit types',
  CHOOSECARVANA: 'choose carvana',
  CUSTOMIZEYOURDEAL: 'customize your deal',
  FAQ: 'faq',
  HERO: 'hero',
  REVIEWS: 'reviews',
  SHOPSTYLES: 'shop styles',
  SHOPTERMS: 'shop terms',
  UNLOCKREALPAYMENTS: 'unlock real payments',
  VALUEPROP: 'value prop',
  WHYCARVANA: 'why carvana'
};

export const ANALYTICS_EVENTS = {
  LOADER: {
    PAGE_RENDERED: `${PREFIX} - loader - page rendered`
  },
  MARKETING: {
    CLICKS_ALLCREDITTYPES_CTA: `${PREFIX} - ${PAGES.MARKETING} - clicks ${SECTION.ALLCREDITTYPES} cta`,
    CLICKS_CHOOSECARVANA_CTA: `${PREFIX} - ${PAGES.MARKETING} - clicks choose carvana cta`,
    CLICKS_FAQ: `${PREFIX} - ${PAGES.MARKETING} - clicks faq`,
    CLICKS_HERO_CTA: `${PREFIX} - ${PAGES.MARKETING} - clicks hero cta`,
    CLICKS_LOGIN_CTA: `${PREFIX} - ${PAGES.MARKETING} - clicks login cta`,
    CLICKS_UNLOCKREALPAYMENTS_CTA: `${PREFIX} - ${PAGES.MARKETING} - clicks ${SECTION.UNLOCKREALPAYMENTS} cta`,
    CLICKS_VALUEPROP_CTA: `${PREFIX} - ${PAGES.MARKETING} - clicks value prop cta`,
    CLICKS_WHYCARVANA_CTA: `${PREFIX} - ${PAGES.MARKETING} - clicks why carvana cta`,
    LOGIN_SUCCEEDED: `${PREFIX} - ${PAGES.MARKETING} - login succeeded`,
    PAGE_RENDERED: `${PREFIX} - ${PAGES.MARKETING} - page rendered`,
    SECTION_VIEWED_ALLCREDITTYPES: `${PREFIX} - ${PAGES.MARKETING} - ${SECTION.ALLCREDITTYPES} section viewed`,
    SECTION_VIEWED_CHOOSECARVANA: `${PREFIX} - ${PAGES.MARKETING} - ${SECTION.CHOOSECARVANA} section viewed`,
    SECTION_VIEWED_FAQ: `${PREFIX} - ${PAGES.MARKETING} - ${SECTION.FAQ} section viewed`,
    SECTION_VIEWED_HERO: `${PREFIX} - ${PAGES.MARKETING} - ${SECTION.HERO} section viewed`,
    SECTION_VIEWED_REVIEWS: `${PREFIX} - ${PAGES.MARKETING} - ${SECTION.REVIEWS} section viewed`,
    SECTION_VIEWED_UNLOCKREALPAYMENTS: `${PREFIX} - ${PAGES.MARKETING} - ${SECTION.UNLOCKREALPAYMENTS} section viewed`,
    SECTION_VIEWED_VALUEPROP: `${PREFIX} - ${PAGES.MARKETING} - ${SECTION.VALUEPROP} section viewed`,
    SECTION_VIEWED_WHYCARVANA: `${PREFIX} - ${PAGES.MARKETING} - ${SECTION.WHYCARVANA} section viewed`
  },
  PREQUALIFIED: {
    CLICKS_ADD_COSIGNER_HERO: `${PREFIX} - ${PAGES.PREQUALIFIED} - clicks add cosigner hero`,
    CLICKS_ADD_COSIGNER: `${PREFIX} - ${PAGES.PREQUALIFIED} - clicks add cosigner`,
    CLICKS_ADD_TRADEIN: `${PREFIX} - ${PAGES.PREQUALIFIED} - clicks add trade-in`,
    CLICKS_BODYSTYLE: `${PREFIX} - ${PAGES.PREQUALIFIED} - clicks bodystyle`,
    CLICKS_EDIT_COSIGNER: `${PREFIX} - ${PAGES.PREQUALIFIED} - clicks edit cosigner`,
    CLICKS_FAQ: `${PREFIX} - ${PAGES.PREQUALIFIED} - clicks faq`,
    CLICKS_HERO_CTA: `${PREFIX} - ${PAGES.PREQUALIFIED} - clicks shop with your terms`,
    CLICKS_SHOPBYCASHDOWN: `${PREFIX} - ${PAGES.PREQUALIFIED} - clicks shop by cash down cta`,
    CLICKS_SHOPBYPAYMENT_CTA: `${PREFIX} - ${PAGES.PREQUALIFIED} - clicks shop by payment cta`,
    CLICKS_VIEW_TRADEIN_DETAILS: `${PREFIX} - ${PAGES.PREQUALIFIED} - clicks view trade-in details`,
    PAGE_RENDERED: `${PREFIX} - ${PAGES.PREQUALIFIED} - page rendered`,
    SECTION_VIEWED_CUSTOMIZEYOURDEAL: `${PREFIX} - ${PAGES.PREQUALIFIED} - ${SECTION.CUSTOMIZEYOURDEAL} section viewed`,
    SECTION_VIEWED_FAQ: `${PREFIX} - ${PAGES.PREQUALIFIED} - ${SECTION.FAQ} section viewed`,
    SECTION_VIEWED_HERO: `${PREFIX} - ${PAGES.PREQUALIFIED} - ${SECTION.HERO} section viewed`,
    SECTION_VIEWED_SHOPSTYLES: `${PREFIX} - ${PAGES.PREQUALIFIED} - ${SECTION.SHOPSTYLES} section viewed`,
    SECTION_VIEWED_SHOPTERMS: `${PREFIX} - ${PAGES.PREQUALIFIED} - ${SECTION.SHOPTERMS} section viewed`,
    SETS_SHOPBYPAYMENT: `${PREFIX} - ${PAGES.PREQUALIFIED} - sets shop by payment dropdown`,
    TERMS_UPDATED: `${PREFIX} - ${PAGES.PREQUALIFIED} - terms updated`,
    TOGGLES_COSIGNER: `${PREFIX} - ${PAGES.PREQUALIFIED} - toggles cosigner`,
    TOGGLES_TRADEIN: `${PREFIX} - ${PAGES.PREQUALIFIED} - toggles trade-in`
  }
};
